import ProfessionalRegistrationComponent from '../components/ProfessionalRegistration/ProfessionalRegistration';
import Navbar from '../components/Navbar/Navbar';

export default function ProfessionalRegistration() {
    return (
        <div>
            <Navbar/>
            <ProfessionalRegistrationComponent/>
        </div>
    )
}